import ListingApi from 'pages/api/listing';
import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import Grid from '../grid/Grid';
import ProductCard1 from '../product-cards/ProductCard1';
import { useSession } from 'next-auth/react';

export interface ProductCard1ListProps {
  productList?: any[];
  keyword?: string;
  condition?: string;
  maxPrice?: number;
  minPrice?: number;
}

const ProductCard1List: React.FC<ProductCard1ListProps> = ({
  productList,
  keyword,
  minPrice,
  maxPrice,
  condition,
}) => {
  const PAGE_SIZE = 10;
  const [searchResult, setSearchResult] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(productList.length > PAGE_SIZE ? true : false); // to handle the case where the first page is the last page
  const [loggedInUserId, setLoggedInUserId] = useState(null);
  const { data: session, status } = useSession();
 const loading = status === 'loading';;

  useEffect(() => {
    setSearchResult(productList);
  }, [productList]);

  const getMoreSearchResults = async () => {
    if (session) {
      setLoggedInUserId(session.userId);
    }
    setPageNumber(pageNumber + 1);
    const res = await ListingApi.searchByParams(
      keyword,
      minPrice,
      maxPrice,
      condition,
      PAGE_SIZE,
      pageNumber,
      null,
      null,
      null,
      loggedInUserId
    );
    setSearchResult([...searchResult, ...res.data.data]);
    setHasMore(res.data.lastPage === pageNumber ? false : true);
  };

  return (
    <div>
      <InfiniteScroll
        dataLength={searchResult.length}
        hasMore={hasMore}
        loader={
          <p style={{ textAlign: 'center', paddingTop: '50px' }}>
            <b> Loading ... ⏳ ⏳</b>
          </p>
        }
        next={getMoreSearchResults}
        style={{ overflow: 'hidden' }}
        endMessage={
          <p style={{ textAlign: 'center', paddingTop: '50px' }}>
            <b>Yay! You have seen it all 🎉 🎉</b>
          </p>
        }
      >
        <Grid container spacing={6}>
          {searchResult.map((product) => {
            return (
              <Grid item lg={3} xs={12} key={product.id}>
                <ProductCard1 {...product} WishLists={product.WishLists} />
              </Grid>
            );
          })}
        </Grid>
      </InfiniteScroll>
    </div>
  );
};

export default ProductCard1List;
